<template>
  <div class="topBox" :class="{ backColorB: bCb_ }">
    <!-- <div class="qq">33</div> -->
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        保存
      </div>
      <button class="topBut" @click="updateSubmit">
        <img :src="bCb_ ? topImgs.yj_bc : topImgs.bz_bc" alt=""
          srcset=""/>
      </button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        Ctrl+Z
        <br />撤销
      </div>
      <button class="topBut" @click="onRetreat"><img :src="bCb_ ? topImgs.yj_cx : topImgs.bz_cx" alt=""
          srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        Ctrl+Y
        <br />恢复
      </div>
      <button class="topBut" @click="onAdvance"><img :src="bCb_ ? topImgs.yj_hf : topImgs.bz_hf" alt=""
          srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        查找/替换
      </div>
      <button class="topBut" :class="{activeBut:isSeekBox===1}" @click="seekShow"><img
          :src="bCb_ ? topImgs.yj_czth : topImgs.bz_czth" alt="" srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        查词
      </div>
      <button class="topBut" @click="rigBoxShow(2)" :class="{activeBut:isSeekBox===2}"><img
          :src="bCb_ ? topImgs.yj_cc : topImgs.bz_cc" alt="" srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        添加术语
      </div>
      <button class="topBut" :style="!ifSubmit_ && 'cursor: no-drop;'" @click="rigBoxShow(3)"
        :class="{activeBut:isSeekBox===3}"><img :src="bCb_ ? topImgs.yj_tjsy : topImgs.bz_tjsy" alt=""
          srcset=""></button>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" placement="bottom" v-if="!isSplite">
      <div slot="content" style="text-align:center">
        拆分句段
      </div>
      <button class="topBut" @click="splitSentence()"><img :src="bCb_ ? topImgs.yj_cf : topImgs.bz_cf" alt=""
          srcset=""></button>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" placement="bottom" v-if="!isSplite">
      <div slot="content" style="text-align:center">
        合并下一句
      </div>
      <button class="topBut" @click="mergeSentence()"><img :src="bCb_ ? topImgs.yj_hb : topImgs.bz_hb" alt=""
          srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        复制到译文
      </div>
      <button class="topBut" @click="copySource()"><img :src="bCb_ ? topImgs.yj_fzyw : topImgs.bz_fzyw" alt=""
          srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        编辑原文
      </div>
      <button class="topBut" :class="{activeBut:isSourceEd_}" @click="sourceEditor()"><img
          :src="bCb_ ? topImgs.yj_edit : topImgs.bz_edit" alt="" srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        重新机翻
      </div>
      <button class="topBut" @click="anewTranslate()"><img :src="bCb_ ? topImgs.yj_cxjf : topImgs.bz_cxjf" alt=""
          srcset=""></button>
    </el-tooltip>
    <!-- <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start"> -->
    <el-popover placement="bottom" :visible-arrow="true" width="320" trigger="hover">
      <ul id="shortcutKey">
        <li class="tit">
          <p>功能</p>
          <p>快捷键</p>
        </li>
        <li v-for="(item, index) in shortcutKeyList" :key="index">
          <p>{{ item.name }}</p>
          <p>{{ item.key }}</p>
        </li>
      </ul>
      <button class="topBut" slot="reference"><img :src="bCb_ ? topImgs.yj_kj : topImgs.bz_kj" alt=""
          srcset=""></button>
    </el-popover>
    <el-tooltip class="item" effect="dark" placement="bottom" v-if="!fileShow">
      <div slot="content" style="text-align:center">
        字体缩放
      </div>
      <el-popover placement="bottom" v-model="visible_size" width="80" trigger="click" v-if="!fileShow">
        <ul style="text-align: center;" class="popoverBox">
          <li @click="onSize(index)" style="margin: 5px 0;cursor: pointer;" v-for="(item, index) in sizeList"
            :key="index">
            {{ item }}
          </li>
        </ul>
        <button class="topBut" slot="reference" :class="{activeBut:visible_size}"><img
            :src="bCb_ ? topImgs.yj_zt : topImgs.bz_zt" alt="" srcset=""></button>
      </el-popover>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        夜间模式
      </div>
      <el-popover placement="bottom" v-model="visible_one" width="80" trigger="click">
        <ul style="text-align: center;" class="popoverBox">
          <li @click="visionPattern(index + 1)" style="margin: 5px 0;cursor: pointer;"
            v-for="(item, index) in patternList" :key="index">
            {{ item }}
          </li>
        </ul>
        <button class="topBut" slot="reference" :class="{activeBut:visible_one}"><img
            :src="bCb_ ? topImgs.yj_msqh : topImgs.bz_msqh" alt="" srcset=""></button>
      </el-popover>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" placement="bottom" v-if="((queryData.sourceLang)!=='mno'&&(queryData.targetLang)!=='mno')">
      <div slot="content" style="text-align:center">
        编辑模式
      </div>

      <el-popover placement="bottom" v-if="toTab" v-model="switching_visible" width="80" trigger="click">
        <ul class="popoverBox" style="text-align: center;">
          <li style="margin: 5px 0;cursor: pointer;" v-for="(item, index) in switchingStylesList" :key="index"
            @click="toTabSty(index,item)">
            {{ item }}
          </li>
        </ul>

        <button class="topBut" slot="reference" :class="{activeBut:switching_visible}">
          <img :src="bCb_ ? topImgs.yj_ms : topImgs.bz_ms" alt="" srcset=""/>
        </button>

      </el-popover>
    </el-tooltip>



    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content" style="text-align:center">
        修改痕迹
      </div>
      <button class="topBut" @click="setRecord" :class="{activeBut:isRecord_}" v-if="isMyPreMt"><img
          :src="bCb_ ? topImgs.yj_record : topImgs.bz_record" alt="" srcset=""></button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" placement="bottom" v-if="isTab">
      <div slot="content" style="text-align:center">
        筛选
      </div>
      <el-popover placement="bottom" v-model="visible_filter" width="204" trigger="click">
        <el-form class="filterForm" label-position="right" label-width="70px" :model="formLabelAlign">
          <el-form-item label="句段状态">
            <el-select v-model="formLabelAlign.transStatus" placeholder="全部" @change="changeFilter">
              <el-option label="全部" value></el-option>
              <el-option label="已确认" value="1"></el-option>
              <el-option label="未确认" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批注">
            <el-select v-model="formLabelAlign.hasComment" placeholder="全部" @change="changeFilter">
              <el-option label="全部" value></el-option>
              <el-option label="带批注句段" value="1"></el-option>
              <el-option label="不带批注句段" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="锁定内容">
            <el-select v-model="formLabelAlign.hasRepeatLock" placeholder="全部" @change="changeFilter">
              <el-option label="全部" value></el-option>
              <el-option label="已锁定内容" value="1"></el-option>
              <el-option label="未锁定内容" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <button class="topBut" slot="reference" :class="{activeBut:visible_filter}"><img
            :src="bCb_ ? topImgs.yj_filter : topImgs.bz_filter" alt="" srcset=""/>
        </button>
      </el-popover>
    </el-tooltip>
    <!-- 右边部分 --- start -->
    <div style="float:right;marginRight:13px">
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          译员评分
        </div>
        <el-popover placement="bottom" width="320" trigger="manual" v-model="visible_scoreList">
          <div class="scoreListTit">{{'译员评分'}} <i class="el-icon-close"
              @click="visible_scoreList = !visible_scoreList"></i></div>
          <ul class="scoreList">
            <li class="scoreTh">
              <span>译员</span>
              <span>准确度</span>
              <span>流畅度</span>
            </li>
            <li class="scoreItem" v-for="(item, index) in scoreList" :key="index" @click="toTabSty(index,item)">
              <span :class="{'interpreterAct':interpreteruid_==item.userId}" class="interpreterName"
                @mouseout="interpreterTaskOut(item)" @mouseover="interpreterTask(item)"
                @click="getTaskHtmlRange(item)">译员{{alphabet[index]}}</span>
              <el-select v-model="item.accuracyScore" :disabled="isScore" placeholder="请选择" @change="insertScore(item)">
                <el-option v-for="i in scoreInterval" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
              <el-select v-model="item.fluencyScore" :disabled="isScore" placeholder="请选择" @change="insertScore(item)">
                <el-option v-for="i in scoreInterval" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
            </li>
          </ul>
          <!-- v-if="queryData_.taskType==2 && !this.$independence"  -->
          <button v-if="queryData_.taskType==2 && !this.$independence" class="topBut" slot="reference"
            @click="visible_scoreList = !visible_scoreList">
            <span class="score_icon">评 <img :src="scoreImg" alt=""></span></button>
        </el-popover>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          译员列表
        </div>
        <el-popover placement="bottom" width="100" trigger="manual" v-model="visible_interpreterList">
          <div class="scoreListTit">{{'译员列表'}} <i class="el-icon-close"
              @click="visible_interpreterList = !visible_interpreterList"></i></div>
          <ul class="scoreList scoreListT">
            <li class="scoreItem" v-for="(item, index) in scoreList" :key="index" @click="toTabSty(index,item)">
              <span :class="{'interpreterAct':interpreteruid_==item.userId}" class="interpreterName"
                @mouseout="interpreterTaskOut(item)" @mouseover="interpreterTask(item)"
                @click="getTaskHtmlRange(item)">{{item.userName}}</span>
            </li>
          </ul>
          <button
            v-show="(queryData_.taskType>1 || queryData_.transStatus==2) && scoreList.length && queryData_.transModel!=1 && isDome"
            class="topBut" slot="reference" @click="visible_interpreterList = !visible_interpreterList">
            <span class="score_icon"><i class="el-icon-user"></i></span></button>
        </el-popover>
      </el-tooltip>

      <!-- 提取术语 -->
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          提取术语
        </div>
        <button class="topBut" :class="{activeBut:ExtractTermsVisible||ExtractTermsTableVisible}"
          v-show="isSplit_ === 0 && isDialog && $privatization && isExtractTerms" @click="extractTerms"><img
            :src="bCb_ ? topImgs.yj_sc : topImgs.bz_sc" alt="" srcset=""></button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" placement="bottom"
        v-show="queryData_.transModel==1 && queryData_.transStatus==2 && queryData_.taskId && istaskScore === null">
        <div slot="content" style="text-align:center">
          作业评分
        </div>
        <button class="topBut" @click="setTaskScoreMess" :class="{activeBut:tit==='作业评分'}"><img
            :src="bCb_ ? topImgs.yj_score : topImgs.bz_score" alt="" srcset=""></button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" placement="bottom"
        v-show="queryData_.transModel==1 && istaskScore !== null">
        <div slot="content" style="text-align:center">
          作业分数
        </div>
        <button class="topBut" style="background:rgba(62,126,244,1);border-radius:4px;color:#fff;top:-8px;width: 50px;"
          @click="setTaskScoreMess">{{taskScore}}分</button>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" placement="bottom" v-if="isReTrans_">
        <div slot="content" style="text-align:center">
          {{retransTit}}
        </div>
        <button class="topBut" @click="retranslationDialogVisible = true"><img
            :src="bCb_ ? topImgs.yj_dhcy : topImgs.bz_dhcy" alt="" srcset=""></button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          QA
        </div>
        <button class="topBut" @click="rigBoxShow(6)" :class="{activeBut:isSeekBox===6}"><img
            :src="bCb_ ? topImgs.yj_qa : topImgs.bz_qa" alt="" srcset=""></button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          下载文件
        </div>
        <el-popover placement="bottom" v-model="visible" width="77" trigger="click">
          <ul class="popoverBox" style="text-align: center;">
            <li @click="changeX(index + 1, item)" :class="current == index" :style="{ margin: m_r, cursor: p_r }"
              v-for="(item, index) in downloadList" :key="index">
              {{ item }}
            </li>
          </ul>
          <button class="topBut" slot="reference" :class="{activeBut:visible}"><img
              :src="bCb_ ? topImgs.yj_xz : topImgs.bz_xz" alt="" srcset=""></button>
        </el-popover>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          提交任务
        </div>
        <button class="topBut" ref="tastSubmit" @click="isSubmit" v-show="termSubmit_"><img
            :src="bCb_ ? topImgs.yj_tj : topImgs.bz_tj" alt="" srcset=""></button>
      </el-tooltip>
      <div class="submit-hint" ref="submitHint" v-show="isSubmitHint && termSubmit_">
        <p>完成任务后，需要点击这里提交哦！</p>
        <div class="submit-arrow"></div>
        <i class="el-icon-close" @click="submitClose()"></i>
      </div>

      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          确认完成
        </div>
        <button class="topBut" @click="isMSubmit" v-show="isSplit_ === 0 && queryData_.transModel != 1"
          :disabled="managerDis"><img :src="bCb_ ? topImgs.yj_wc : topImgs.bz_wc" alt="" srcset=""></button>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content" style="text-align:center">
          添加到记忆库
        </div>
        <button class="topBut" @click="isMemory" :class="{activeBut:mesBox||tit==='添加到记忆库'}" v-show="termState"><img
            :src="bCb_ ? topImgs.yj_tjjy : topImgs.bz_tjjy" alt="" srcset=""></button>
      </el-tooltip>
    </div>
    <!-- 右边部分 --- end -->
    <messageBox v-if="mesBox" :isShow="mesBox" :mesShow="mesShow" :tit="tit" :txt="txt" :imgSrc="imgSrc"
      :params="taskScore" zIndex="2500" @message="empty" @messageIf="messageIf"></messageBox>
    <div class="extract_terms">
      <el-dialog title="提取术语" :visible.sync="ExtractTermsVisible" :close-on-click-modal="false" :showClose="false"
        width="20%" top="30vh" center>
        <div class="division"></div>
        <div class="extract_terms_loading">
          <span>提取术语中，请稍候...</span>
          <img src="../../../assets/imgs/editor/extractTermsLoading.gif" alt="">
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="ExtractTermsVisible = false">取 消</el-button>
          <el-button type="primary" @click="ExtractTermsVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="extract_terms_table">
      <el-dialog title="提取术语" :visible.sync="ExtractTermsTableVisible" :closeOnClickModal="false" width="60%" top="15vh"
        center>
        <div class="extract_terms_table_title">提取完成，共提取到{{termNum}}个术语</div>
        <div class="extract_terms_loading">

          <el-table class="termTable" ref="termTable" v-loading="isLoading" element-loading-text="术语保存替换中..."
            :data="tableData" tooltip-effect="dark" :header-cell-style="{background:'#EDECEC',color:'#  454545'}" border
            :resizable="false">

            <el-table-column :resizable="false" type="index" label="序号" :index="getIndex" width="80"></el-table-column>
            <!--<el-table-column :resizable="false" type="selection" width="60"></el-table-column>-->
            <el-table-column :resizable="false" prop="sourceSent" label="原文">

              <template slot-scope="scope">
                <div v-if="scope.$index === 0">
                  <input class="term-input" v-model="addTermSentData.sourceSent" placeholder="请输入原文"
                    @blur="changeUpdate(scope.$index, scope.row, $event, 0)" />
                </div>
                <div v-else contenteditable="true" @blur="changeUpdate(scope.$index, scope.row, $event, 0)"
                  v-html="scope.row.sourceSent">scope.$index</div>
              </template>

            </el-table-column>

            <el-table-column :resizable="false" prop="targetSent" label="译文" width>
              <template slot-scope="scope">
                <div v-if=" scope.$index === 0">
                  <input class="term-input" v-model="addTermSentData.targetSent" placeholder="请输入译文"
                    @blur="changeUpdate(scope.$index, scope.row, $event, 1)" />
                </div>
                <div v-else contenteditable="true" @blur="changeUpdate(scope.$index, scope.row, $event, 1)"
                  v-html="scope.row.targetSent"></div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" :resizable="false" align="center">
              <template slot-scope="scope">
                <div class="operation">
                  <el-tooltip content="删除" placement="top">
                    <div class="icon_delete" style="cursor:pointer;" @click="deleteTermSent(scope.$index, scope.row)">
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeTerm">取 消</el-button>
          <el-button type="primary" @click.once="subminTerm">保存并替换</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog :title="retransTit" :visible.sync="retranslationDialogVisible" class="retranslationDialog">
      <span>{{retransText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="retranslationDialogVisible = false">取 消</el-button>
        <el-button class="confirm-btn" type="primary" @click="reTranslation">确 定</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <el-dialog title="请对译员评分" :visible.sync="scoreDialogVisible" class="retranslationDialog interpreterDialog ">
      <ul class="interpreterList">
        <li v-for="(item, index) in scoreList" :key="index">
          <div class="tit">
            <span class="line"></span>
            <span class="interpreterName">译员{{alphabet[index]}}</span>
          </div>

          <div class="inputBox accuracyScore">
            <span class="interpreterName">准确度：</span>
            <el-select v-model="item.accuracyScore" placeholder="请选择" @change="insertScore(item)">
              <el-option v-for="i in scoreInterval" :key="i" :label="i" :value="i">
              </el-option>
            </el-select>
          </div>
          <div class="inputBox">
            <span class="interpreterName">流畅度：</span>
            <el-select v-model="item.fluencyScore" placeholder="请选择" @change="insertScore(item)">
              <el-option v-for="i in scoreInterval" :key="i" :label="i" :value="i">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="bottom"></li>
      </ul>
      <p class="interpreterHint">注：评分提交后不可更改</p>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="scoreDialogVisible = false">取 消</el-button>
        <el-button class="confirm-btn" type="primary" @click="finishAndScoreTask(false)">确 定</el-button>
      </span>
    </el-dialog>
    <!--  -->
  </div>
</template>
<script>
import messageBox from "@/common/messageBox.vue";
import debounce from "lodash.debounce";
import throttle from 'lodash.throttle';
// import eventBus from './eventBus'
export default {
  name: "editorTop",
  props: [
    "taskTypeName",
    "queryData",
    "bCb",
    "termSubmit",
    "fileShow",
    "roleLevel",
    "isSeekBox",
    "sentenceShow",
    "isSourceEd",
    "isSplit",
    "ifSubmit",
    "isRecord",
    "isPreMt",
    "interpreteruid"
  ],
  data() {
    return {
      queryData_: this.queryData,
      termState: false,
      managerDis: false,
      formInline: "",
      fileId_: this.queryData.fileId,
      progressIf_: this.queryData.progressIf,
      fileSuffix_: this.queryData.fileSuffix,
      mesBox: false,
      tit: "",
      txt: "",
      imgSrc: require("../../../assets/imgs/project/qr_code_bg.png"), // 弹窗title背景图
      shortcutKeyList: [
        { name: "复制", key: "ctrl+c" },
        { name: "剪切", key: "ctrl+x" },
        { name: "粘贴", key: "ctrl+v" },
        { name: "查找", key: "ctrl+f" },
        { name: "上一句", key: "shift+tab" },
        { name: "下一句", key: "tab或enter" },
        { name: "添加术语", key: "ctrl+b" },
        { name: "确认候选单词（单词补全）", key: "→" },
        { name: "句段内全选", key: "ctrl+a" },
        { name: "句段内选中单词", key: "ctrl+shift+→/←" },
        { name: "显示右侧菜单", key: "ctrl+m" },
      ],
      taskTypeName_: this.taskTypeName,
      vision: "",
      downloadList: EDIT_DOWNLOAD_LIST,
      visible: false, //
      visible_one: false,
      switching_visible: false,
      visible_size: false,
      visible_filter: false,
      visible_scoreList: false,
      visible_interpreterList: false,
      patternList: ["标准模式", "夜间模式"],
      sizeList: ["放大", "缩小"],
      switchingStylesList: ["上下对照", "表格对照"],
      current: 0, //高亮显示标识
      toTab: true,
      m_r: "5px",
      p_r: "pointer",
      ExtractTermsVisible: false,// 提取术语loading框
      ExtractTermsTableVisible: false,//提取术语表格
      isPopover: false,
      termNum: 0,// 术语条目数
      creatorId: 1,// 创建者id
      updaterId: 0,
      sourceLang: "",// 源语言
      targetLang: "",// 目标语言
      isLoading: false,// 保存术语loading
      isCancel: false,//提取术语后是否可取消
      tableData: [],
      addTermSentData: {
        sourceSent: '',
        targetSent: ''
      },
      isDialog: false,
      topImgs: {
        bz_bc: require("../../../assets/imgs/editor/bz_bc.png"),
        yj_bc: require("../../../assets/imgs/editor/yj_bc.png"),
        bz_cx: require("../../../assets/imgs/editor/bz_cx.png"),
        yj_cx: require("../../../assets/imgs/editor/yj_cx.png"),
        bz_hf: require("../../../assets/imgs/editor/bz_hf.png"),
        yj_hf: require("../../../assets/imgs/editor/yj_hf.png"),
        bz_czth: require("../../../assets/imgs/editor/bz_czth.png"),
        yj_czth: require("../../../assets/imgs/editor/yj_czth.png"),
        bz_cc: require("../../../assets/imgs/editor/bz_cc.png"),
        yj_cc: require("../../../assets/imgs/editor/yj_cc.png"),
        bz_tjsy: require("../../../assets/imgs/editor/bz_tjsy.png"),
        yj_tjsy: require("../../../assets/imgs/editor/yj_tjsy.png"),
        bz_kj: require("../../../assets/imgs/editor/bz_kj.png"),
        yj_kj: require("../../../assets/imgs/editor/yj_kj.png"),
        bz_zt: require("../../../assets/imgs/editor/bz_zt.png"),
        yj_zt: require("../../../assets/imgs/editor/yj_zt.png"),
        bz_ms: require("../../../assets/imgs/editor/bz_ms.png"),
        yj_ms: require("../../../assets/imgs/editor/yj_ms.png"),
        bz_msqh: require("../../../assets/imgs/editor/bz_msqh.png"),
        yj_msqh: require("../../../assets/imgs/editor/yj_msqh.png"),
        bz_xz: require("../../../assets/imgs/editor/bz_xz.png"),
        yj_xz: require("../../../assets/imgs/editor/yj_xz.png"),
        bz_wc: require("../../../assets/imgs/editor/bz_wc.png"),
        yj_wc: require("../../../assets/imgs/editor/yj_wc.png"),
        bz_tjjy: require("../../../assets/imgs/editor/bz_tjjy.png"),
        yj_tjjy: require("../../../assets/imgs/editor/yj_tjjy.png"),
        bz_qa: require("../../../assets/imgs/editor/bz_qa.png"),
        yj_qa: require("../../../assets/imgs/editor/yj_qa.png"),
        bz_tj: require("../../../assets/imgs/editor/bz_tj.png"),
        yj_tj: require("../../../assets/imgs/editor/yj_tj.png"),
        bz_sc: require("../../../assets/imgs/editor/bz_sc.png"),
        yj_sc: require("../../../assets/imgs/editor/yj_sc.png"),
        bz_cf: require("../../../assets/imgs/editor/bz_cf.png"),
        yj_cf: require("../../../assets/imgs/editor/yj_cf.png"),
        bz_hb: require("../../../assets/imgs/editor/bz_hb.png"),
        yj_hb: require("../../../assets/imgs/editor/yj_hb.png"),
        bz_fzyw: require("../../../assets/imgs/editor/bz_fzyw.png"),
        yj_fzyw: require("../../../assets/imgs/editor/yj_fzyw.png"),
        bz_cxjf: require("../../../assets/imgs/editor/bz_cxjf.png"),
        yj_cxjf: require("../../../assets/imgs/editor/yj_cxjf.png"),
        bz_edit: require("../../../assets/imgs/editor/bz_edit.png"),
        yj_edit: require("../../../assets/imgs/editor/yj_edit.png"),
        bz_filter: require("../../../assets/imgs/editor/bz_competition_selection.png"),
        yj_filter: require("../../../assets/imgs/editor/yj_competition_selection.png"),
        bz_score: require("../../../assets/imgs/editor/bz_score.png"),
        yj_score: require("../../../assets/imgs/editor/yj_score.png"),
        bz_record: require("../../../assets/imgs/editor/bz_modification_record.png"),
        yj_record: require("../../../assets/imgs/editor/yj_modification_record.png"),
        bz_dhcy: require("../../../assets/imgs/editor/bz_dhcy.png"),
        yj_dhcy: require("../../../assets/imgs/editor/yj_dhcy.png"),
      },
      isSplite: false,
      isTab: false,
      formLabelAlign: {
        hasComment: '',
        hasRepeatLock: '',
        transStatus: '',
      },
      taskScore: 0,
      mesShow: "",
      isRecord_: true,
      downloadPercent: 0,
      downloadLoading: "",
      istaskScore: null,
      isMyPreMt: false,
      retranslationDialogVisible: false,  //打回重译确认弹窗
      scoreDialogVisible: false, // 译员评分确认窗口
      operated: false, //已操作过打回重译
      progress: 0, //当前任务进度
      userInfo: { id: -1 },
      isSubmitHint: false, // 提交提示
      scoreList: [],
      scoreInterval: [0, 1, 2, 3, 4, 5],
      alphabet: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      antiRecord: true,
      retransTit: "打回重译",
      retransText: "确定要将本任务打回给译员重新翻译吗？",
      isScore: false,
      scoreImg: require('../../../assets/imgs/editor/we_pingfen.png'),
      scores: [],
      isDome: false,
      isExtractTerms:IS_EXTRACT_TERMS // 是否支持提取术语
    };
  },
  components: {
    messageBox,
  },
  computed: {
    termSubmit_: function () {
      this.setSubmithint();
      return this.termSubmit;
    },
    bCb_: function () {
      return this.bCb;
    },
    isSeekBox_() {
      return this.isSeekBox
    },
    sentenceShow_() {
      return this.sentenceShow
    },
    isSourceEd_() {
      return this.isSourceEd
    },
    isSplit_() {
      return this.isSplit
    },
    ifSubmit_() {
      return this.ifSubmit
    },
    isPreMt_() {
      return this.isPreMt
    },
    isReTrans_() {
      //只有一个任务,项目进入,任务id是自己
      if (this.queryData.taskCount === 1 && this.queryData.transStatus === 2 && this.queryData.userId === this.userInfo.id) {
        return false;
      }
      return this.progress === 100 && this.queryData.taskId && this.queryData.transStatus === 2 && !this.operated
    },
    interpreteruid_() {
      return this.interpreteruid
    }
    // isRecord_(){
    //   return isRecord
    // }
    // isSourceEd_:{
    //   get() {
    //     return this.isSourceEd
    //   },
    //   set(val) {
    //     this.$emit('setIsSourceEd', val)
    //   }
    // }
  },
  async created() {
    if (process.env.VUE_APP_HOSPITAL === "demo") {
      this.isDome = true
    }
    this.setRecord = throttle(this.setRecord1, 3000);
    // this.isRecord_ = sessionStorage.getItem("isRecord")=='true' ? true : false;
    // if (sessionStorage.getItem("isRecord")) {
    //   this.isRecord_ = sessionStorage.getItem("isRecord")=='true' ? true : false;
    // }
    if (this.queryData_.taskType > 1) {
      this.retransTit = "打回重审";
      this.retransText = "确定要将本任务打回给审校人员重新审校吗？"
    }
    if (this.queryData_.sourceLang === "en" || this.queryData_.sourceLang === "zh") {
      this.isDialog = true
    }
    this.isExtract = this.queryData.isExtract;
    if (
      (this.fileSuffix_ === "doc" ||
        this.fileSuffix_ === "docx" ||
        this.fileSuffix_ === "txt" ||
        this.fileSuffix_ === "pdf")
      // this.$route.name === "WordEditor"
    ) {
      this.switchingStylesList.splice(1, 0, "左右对照")
    } else if (this.fileSuffix_ === "xlf") {
      this.downloadList.pop();
      this.downloadList.splice(2, 1);
    }
    let myUser = localStorage.getItem("myUser");
    if (myUser) {
      this.userInfo = JSON.parse(myUser);
    }
    if (!this.$independence) { // 非私有化部署
      await this.queryByTransFileId();
    }
    this.getTaskList();


  },
  mounted() {
    let that = this;
    if (!localStorage.getItem("tastSubmit")) {
      window.onresize = function () { // 定义窗口大小变更通知事件
        that.setSubmithint()
      };
    }

    if (
            (this.fileSuffix_ === "ppt") ||
            (this.fileSuffix_ === "pptx") ||
            (this.fileSuffix_ === "html") ||
            (this.fileSuffix_ === "xlf") ||
            (this.fileSuffix_ === "htm") ||
            (this.fileSuffix_ === "eml")
    ) {
      this.toTab = false;
    } else if (
      this.fileSuffix_ === "xls" ||
      this.fileSuffix_ === "xlsx"
    ) {
      this.isSplite = true;
    }

    if (IS_TABLE) {
      this.toTab = false;
    }
    this.$route.name == 'wordEditorTier' ? this.isSplite = true : '';
    this.$route.name == 'editorTab' ? this.isTab = true : '';
    if ((this.$route.name == 'wordEditorTier' || this.$route.name == 'editor') && this.isPreMt_) {
      setTimeout(() => {
        this.isMyPreMt = true;
      }, 3000);
    } else {
      this.isMyPreMt = false;
    }
    this.getTermState();
    if (this.queryData_.taskId && this.queryData_.transModel == 1) {
      this.getTaskDetail();
    }
    // if (this.queryData_.transStatus === 2) {
    /// 预翻译提示
    // }
    //获取任务状态
    let params = {
      fileId: this.queryData.fileId,
      taskId: this.queryData.taskId,
      taskType: this.queryData.taskType,
    };
    this.catReq1Service("/api/v1/fileTask/get_task_progress_by_task_id", params).then(
      function (response) {
        if (!response.success) {
          return;
        }
        console.log("状态查询：", response)
        that.progress = response.result.progress
      })
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    // 获取任务对应的HTML页码
    async getTaskHtmlRange(item) {
      const params = {
        taskId: item.id
      }
      const { result, resultCode } = await this.catReq1Service("/api/v1/file/getTaskHtmlRange", params);
      if (resultCode === '1') {
        result.uid = item.userId
        this.$emit('toTaskIndex', result, this.scoreList)
      }
    },
    // 批量评分
    async finishAndScoreTask(isConfirm) {

      let scoreList = [], num = 0;
      this.scoreList.forEach(i => {
        scoreList.push({
          accuracyScore: i.accuracyScore,
          fluencyScore: i.fluencyScore,
          taskId: i.id
        })
        if (i.is) {
          num++
        }
      })
      if (num !== scoreList.length && !isConfirm) {
        this.isDidNotScore()
        return
      } else {
        this.scoreDialogVisible = false
      }
      const params = {
        scoreList,
        taskId: this.queryData.taskId
      }
      const { result, resultCode } = await this.catReq1Service("/api/v1/taskScore/finishAndScoreTask", params);
      if (resultCode === '1') {
        // this.$message.closeAll();
        // this.$message({
        //   message: '评分成功',
        //   type: "success",
        // });
        this.$emit("submit");
      }
    },
    // 新增评分
    async insertScore(item) {
      const params = {
        accuracyScore: item.accuracyScore,
        fluencyScore: item.fluencyScore,
        taskId: item.id
      }
      this.scoreList.forEach(i => {
        if (i.id === item.id) {
          i.accuracyScore = item.accuracyScore;
          i.fluencyScore = item.fluencyScore;
          i.is = true;
        }
      })
      localStorage.setItem('myScoreList' + this.queryData_.taskId, JSON.stringify(this.scoreList))
      // const { result, resultCode } = await this.catReq1Service("/api/v1/taskScore/insertScore", params);
      // if (resultCode === '1') {
      //   this.$message.closeAll();
      //   this.$message({
      //     message: '评分成功',
      //     type: "success",
      //   });
      // }
    },
    // 取消译员任务段落高亮
    interpreterTaskOut() {
      this.$emit("interpreterTaskOut")
    },
    // 译员任务段落高亮
    interpreterTask(item) {
      this.$emit('interpreterTask', item.userId)
    },
    // 根据文件id查询评分
    async queryByTransFileId() {
      const params = {
        id: this.fileId_,
      }
      const { result, resultCode } = await this.catReq1Service("/api/v1/taskScore/queryByTransFileId", params);
      if (resultCode === '1' && result.length) {
        this.scores = result;
        this.isScore = true;
        this.scoreImg = require('../../../assets/imgs/editor/pingfen.png')
        this.scores.forEach(item => {
          item.userId = item.taskUserId;
        })
      } else {
        this.scores = JSON.parse(localStorage.getItem('myScoreList' + this.queryData_.taskId)) || []
      }
    },
    // 获取译员列表
    async getTaskList() {
      const params = {
        fileId: this.fileId_,
        taskType: 1
      };
      const { result, resultCode } = await this.catReq1Service("/api/v1/fileTask/task_list", params);


      if (resultCode === '1') {
        if((!!result)){
          result.forEach(item => {
            item.accuracyScore = 0;
            item.fluencyScore = 0;
            this.scores.forEach(i => {
              if (i.userId === item.userId) {
                item.accuracyScore = i.accuracyScore // 准确度
                item.fluencyScore = i.fluencyScore; // 流畅度
                item.is = true;
              }
            })
          })
          this.scoreList = result;
        }

      }
    },
    // 提交提示
    setSubmithint() {
      this.$nextTick(() => {
        if (!localStorage.getItem("tastSubmit") && this.termSubmit_) {
          setTimeout(() => {
            this.isSubmitHint = true;
            let disx = this.$refs.tastSubmit.offsetLeft;
            let disy = this.$refs.tastSubmit.offsetTop;
            let disW = this.$refs.tastSubmit.offsetWidth;
            const submitDom = this.$refs.submitHint;
            submitDom.style.left = disx - 170 + disW + "px";
            submitDom.style.top = disy + 32 + "px";
          }, 100);
        }
      })
    },
    submitClose() {
      this.isSubmitHint = false;
      localStorage.setItem("tastSubmit", true)
    },
    // 查询任务详情
    async getTaskDetail() {
      const res = await this.catReq1Service(
        "/api/v1/fileTask/getTaskDetail", {
        id: this.queryData_.taskId,
      }
      );
      if (res.success) {
        this.istaskScore = res.result.taskScore;
        this.taskScore = Number(res.result.taskScore);  // 获取分数
      }
    },
    // 打分
    setTaskScoreMess() {
      if (this.queryData_.transStatus == 1) {
        return
      }
      this.tit = "作业评分";
      this.txt = "";
      this.mesBox = true;
      this.mesShow = 'rate';
    },
    async setTaskScore(data) {
      if (this.queryData_.transStatus != 2) {
        this.$message.closeAll();
        this.$message({
          message: '您无打分权限哦',
          type: "warning",
        });
        return
      }
      let params = {
        id: this.queryData_.taskId,
        taskScore: data + ""
      }
      const res = await this.catReq1Service("/api/v1/fileTask/taskScore", params);
      if (res.success) {
        this.taskScore = Number(data);
        this.istaskScore = data;
        this.$message({
          message: '打分成功',
          type: "success",
        });
      }
    },
    sourceEditor() {
      this.$emit("sourceEditor")
    },
    changeFilter() {
      this.$emit("changeFilter", this.formLabelAlign)
    },
    copySource() {
      if (!this.sentenceShow_) {
        this.$message.closeAll();
        this.$message({
          message: '光标在在原文区内时才能复制原文到译文哦~',
          type: "warning",
        });
        return
      }
      this.$emit("copySource")
    },
    anewTranslate() {
      if (!this.sentenceShow_) {
        this.$message.closeAll();
        this.$message({
          message: '光标在在原文区内时才能重新机翻哦~',
          type: "warning",
        });
        return
      }
      this.$emit("anewTranslate")
    },
    mergeSentence() {
      if (!this.sentenceShow_) {
        this.$message.closeAll();
        this.$message({
          message: "光标在在原文区内时才能合并句段哦~",
          type: "warning",
        });
        return
      }
      this.$emit("mergeSentence")
    },
    splitSentence() {
      if (!this.sentenceShow_) {
        this.$message.closeAll();
        this.$message({
          message: "光标在在原文区内时才能拆分句段哦~",
          type: "warning",
        });
        return
      }
      this.$emit("splitSentence")
    },

    // 删除术语
    async deleteTermSent(index, rowData) {
      this.tableData.splice(index, 1)
    },
    // 放大缩小
    onSize(data) {
      if (data) {
        this.$emit("sizeNarrow");
      } else {
        this.$emit("sizeEnlarge");
      }
    },
    // 修改
    async changeUpdate(index, row, e, type) {

      let that = this
      let data = e.target.value || e.target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      let sent = !type ? row.sourceSent : row.targetSent
      if (sent === data) {
        return
      }

      //新增
      if (!row.creatorId) {
        if (this.addTermSentData.sourceSent.trim() === '' || this.addTermSentData.targetSent.trim() === '') {

          return;
        }
        if (this.addTermSentData.sourceSent.trim().length >= 100) {
          this.$message({
            message: `术语长度不能超过100`,
            type: "warning",
          });
          return
        }
        if (this.addTermSentData.targetSent.trim().length >= 100) {
          this.$message({
            message: `译文长度不能超过100`,
            type: "warning",
          });
          return
        }
        let params = {
          creatorId: this.creatorId,
          sourceSent: this.addTermSentData.sourceSent.trim(),
          targetSent: this.addTermSentData.targetSent.trim()
        }

        this.tableData.forEach((item, index) => {
          if (item.sourceSent === params.sourceSent) {
            that.tableData.splice(index, 1)
          }
        })
        this.tableData.splice(1, 0, params)
        // this.$set(this.tableData, this.addTermSentData, params)
        this.addTermSentData.sourceSent = '';
        this.addTermSentData.targetSent = '';
      } else {
        if (!type) {
          if (data.trim() == "") {
            this.$message({
              message: `原文参数不可为空`,
              type: "warning",
            });
            e.target.innerText = row.sourceSent
            return
          }
          if (data.trim().length >= 100) {
            this.$message({
              message: `术语长度不能超过100`,
              type: "warning",
            });
            e.target.innerText = row.targetSent
            return
          }
          let isFlag = false
          let text = ""
          let arr = [...that.tableData]
          arr.forEach((item, index) => {
            if (item.sourceSent === data) {
              text = row.sourceSent
              isFlag = true
            }
          })
          if (isFlag) {
            this.$message({
              message: `术语明细已存在`,
              type: "warning",
            });
            this.tableData[index].sourceSent = row.sourceSent
            e.target.innerText = row.sourceSent
            // console.log(this.tableData[index])
            // this.$set(this.tableData, this.tableData[index], params)
          } else {
            this.tableData[index].sourceSent = data
          }

        } else {
          if (data.trim() == "") {
            this.$message({
              message: `译文参数不可为空`,
              type: "warning",
            });
            e.target.innerText = row.targetSent
            return
          }
          if (data.trim().length >= 100) {
            this.$message({
              message: `译文长度不能超过100`,
              type: "warning",
            });
            e.target.innerText = row.targetSent
            return
          }
          this.tableData[index].targetSent = data
        }

      }
    },
    // 提交术语
    async subminTerm() {
      let that = this
      if (this.tableData.length === 1) {
        this.$message({
          message: `没有可以保存并替换的术语`,
          type: "warning",
        });
        return;
      }
      this.isLoading = true
      this.isCancel = true
      let tertArr = []
      let arr = [...this.tableData]
      arr.shift()
      arr.forEach(item => {
        let params = {
          creatorId: that.creatorId,
          // langDesc: that.objData.langDesc,
          sourceLang: that.sourceLang,
          sourceSent: item.sourceSent,
          targetLang: that.targetLang,
          targetSent: item.targetSent,
          updaterId: that.creatorId
        }
        tertArr.push(params)
      })
      try {
        let par = {
          fileId: this.fileId_,
          list: tertArr
        }
        const res = await this.catReq1Service("/api/v1/termSent/batchAddSent", par)
        const resultCode = res.resultCode;
        const data = res.result;
        if (resultCode !== "1") {
          this.ExtractTermsTableVisible = false
          this.isLoading = false
          this.isCancel = false
        }
        if (resultCode === "1") {
          this.ExtractTermsTableVisible = false
          this.isLoading = false
          this.isCancel = false
          this.$message({
            message: '术语保存并替换成功！',
            type: 'success'
          });
          this.isExtract = true;
          this.$nextTick(() => {
            if (data.length > 0) {
              switch (this.$route.name) {
                case "editor":
                  let sourceText = document.getElementById("sourceText");
                  let translation = document.getElementById("translation");
                  data.forEach(item => {
                    let itemDom = sourceText.querySelector(
                      `span[sid='${item.id}']`);
                    let itemDom2 = translation.querySelector(
                      `span[sid='${item.id}']`);
                    itemDom ? itemDom.innerHTML = item.sourceSent : null;
                    itemDom2 ? itemDom2.innerHTML = item.targetSent : null;
                  })
                  break;
                case "editorXls":
                  data.forEach(item => {
                    let translation = document.getElementById("translation");
                    let itemDom = translation.querySelectorAll(`div[sid='${item.id}']`);
                    itemDom[0] ? itemDom[0].innerHTML = item.sourceSent : null;
                    itemDom[1] ? itemDom[1].innerHTML = item.targetSent : null;
                  })
                  break;
                case "editorTab":
                  this.$emit("setTermSent", data)
                  break;
                case "wordEditorTier":
                  data.forEach(item => {
                    let translation = document.getElementById("translation");
                    let itemDom = translation.querySelectorAll(`span[sid='${item.id}']`);
                    itemDom[0] ? itemDom[0].innerHTML = item.sourceSent : null;
                    itemDom[1] ? itemDom[1].innerHTML = item.targetSent : null;
                  })
                  break;
                default:
                  break;
              }


            }
          })
          this.reload()
        }
      } catch (error) {
        this.ExtractTermsTableVisible = false
        this.isLoading = false
        this.isCancel = false
      }
    },
    closeTerm() {
      if (this.isCancel) {
        this.$message.closeAll();
        this.$message({
          message: `术语保存替换中...`,
          type: "warning",
        });
        return;
      } else {
        this.ExtractTermsTableVisible = false
      }
    },
    getIndex(index) {
      if (index === 0) {
        return "#";
      }
      if (index !== 0) {
        return index;
      }
      return index + 1;
    },
    // 提取术语弹框
    async extractTerms() {
      if (this.isExtract) {
        this.$message.closeAll();
        this.$message({
          message: `文件不可提取术语或已经提取过术语`,
          type: "warning",
        });
        return;
      }
      this.isPopover = false // 禁止点击遮罩层关闭
      this.ExtractTermsVisible = true  // 提取loading
      let params = {
        id: this.queryData_.fileId,
        list: [],
      }
      try {
        const res = await this.catReq1Service("/api/v1/termSent/getFileTermLib", params)
        if (!res || res.resultCode === "0") {
          this.ExtractTermsVisible = false
          return
        }
        if (res.resultCode == "1" && res.result.length == 0) { // 提取术语成功，但是术语列表为空
          this.$message({
            message: `没有提取到建议的术语~`,
            type: "warning",
          });
          this.ExtractTermsVisible = false
          return
        }
        if (res.resultCode == "1" && res.result.length > 0) {
          this.tableData = res.result // 术语列表数组
          this.termNum = res.result.length // 提取数量
          this.creatorId = res.result[0].creatorId // 创建者id
          this.sourceLang = res.result[0].sourceLang
          this.targetLang = res.result[0].targetLang
          this.tableData.splice(0, 0, {
            sourceSent: "请添加原文",
            targetSent: "请添加译文"
          })
          this.ExtractTermsVisible = false
          this.ExtractTermsTableVisible = true // 提取表
        }
      } catch (error) {
        this.ExtractTermsVisible = false
      }
    },
    /// 跳转表格样式
    toTabSty(key, name) {
      let path;
      switch (name) {
        case "上下对照":
          path = "/wordEditorTier";
          name = "上下对照";
          if (this.fileSuffix_ === "xlsx" || this.fileSuffix_ === "xls") {
            path = "/editorXls";
          }
          break;
        case "左右对照":
          path = "/editor";
          name = "左右对照";
          break;
        case "表格对照":
          path = "/editorTab";
          name = '纯表格';
          if (this.fileSuffix_ === 'ppt' || this.fileSuffix_ === 'pptx') {
            name = '预览+表格';
          }
          break;
        default:
          break;
      }
      // if (key == 1) {
      //   path = "/editorTab";
      // } else if (this.fileSuffix_ === "xlsx" || this.fileSuffix_ === "xls") {
      //   path = "/editorXls";
      // } else {
      //   path = "/editor";
      // }
      this.editorStatisticsPattern(name)
      this.$router.push({
        path,
        query: {
          key: this.$Base64.encode(JSON.stringify(this.queryData_)),
        },
      });
      // window.open(routeData.href, '_blank')
    },
    async editorStatisticsPattern(name) {
      const rName = this.$route.name;
      let content, optMark;
      switch (rName) {
        case 'wordEditorTier':
          content = '上下对照';
          optMark = '1';
          break;
        case 'editor':
          content = '左右对照';
          optMark = '2';
          break;
        case 'editorTab':
          content = '纯对照';
          optMark = '3';
          if (this.fileSuffix_ === 'ppt' || this.fileSuffix_ === 'pptx') {
            content = '预览+表格';
            optMark = '4';
          }
          break;
        case 'editorXls':
          content = '上下对照';
          optMark = '1';
          break;
        default:
          break;
      }
      let optContent = `从${content}切换到${name}`
      const params = {
        optContent,
        optMark,
        optType: 'changeEditor',
        transFileId: this.fileId_
      }
      const res = await this.catReq1Service("/api/v1/userLog/insert", params, 'post', 2)
    },
    // 获取是否添加过记忆库状态
    getTermState() {
      var that = this;
      this.catReq1Service("/api/v1/memory/checkHasGenerate", {
        id: this.fileId_,
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        if (response.result.hasGenerate === true) {
          that.termState = false;
        } else if (that.roleLevel < 3) {
          that.termState = true;
        } else {
          that.termState = false;
        }
      });
    },
    // 添加到记忆库
    addMemory() {
      let that = this;
      this.catReq1Service("/api/v1/memory/generateMemoryLib", {
        fileId: that.fileId_,
        taskId: this.queryData_.taskId
      }).then(function (response) {
        if (response.resultCode === "1") {
          that.$message({
            message: "添加记忆库成功",
            type: "success",
          });
          that.getTermState();
        }
      });
    },
    empty(data) {
      switch (this.tit) {
        case "添加到记忆库":
          this.tit = "";
          this.mesBox = false;
          this.addMemory();
          break;
        case "提交任务":
          this.mesBox = false;
          this.$emit("submit");
          break;
        case "全部确认":
          this.mesBox = false;
          this.managerSubmit();
          break;
        case "翻译提示":
          this.mesBox = false;
          this.backtrack();
          break;
        case "作业评分":
          this.mesBox = false;
          this.mesShow = "";
          this.tit = "";
          this.setTaskScore(data);
        case "提示":
          this.mesBox = false;
          this.mesShow = "";
          this.tit = "";
          this.finishAndScoreTask(true);
          break;
        default:
          break;
      }
    },
    // 返回上一页
    backtrack() {
      let that = this;
      if (that.queryData_.transStatus == 2) {
        that.$router.push({ name: "fileList" });
      } else {
        that.$router.push({ name: "myTask" });
      }
    },
    messageIf() {
      if (this.mesBox) {
        this.tit = "";
        this.mesBox = false;
        this.mesShow = "";
      } else {
        this.mesBox = true;
      }
    },
    // 预翻译弹窗
    isBring() {
      this.tit = "翻译提示";
      this.txt = "正在预翻译中，建议预翻译完成后再编辑~";
      this.mesBox = true;
    },
    // 添加记忆库弹窗
    isMemory() {
      this.tit = "添加到记忆库";
      this.txt = "确认将全文句段添加到我的记忆库？";
      this.mesBox = true;
    },
    // 提交任务弹窗
    isSubmit() {
      if (this.queryData_.taskType == 2 && !this.$independence) {  // 如果任务类型是审校则
        this.reviserSubmit()
        return
      }
      this.tit = "提交任务";
      this.txt = "确认本任务完成并提交给项目经理？";
      this.mesBox = true;
    },
    // 审校提交任务弹窗
    async reviserSubmit() {
      // await this.queryByTransFileId();
      console.log(this.scoreList, "???");
      this.scoreDialogVisible = true

    },
    // 添加记忆库弹窗
    isDidNotScore() {
      this.tit = "提示";
      this.txt = "尚有译员未评分，是否提交？";
      this.mesBox = true;
    },
    // 确认完成弹窗
    isMSubmit() {
      this.tit = "全部确认";
      this.txt = "确认本任务完成？";
      this.mesBox = true;
    },
    // 项目经理 提交
    managerSubmit() {
      let that = this;
      that.managerDis = true;
      let params = {
        fileId: that.fileId_,
        langDesc: that.queryData_.langDesc,
      };
      this.catReq1Service("/api/v1/fileTask/finishFile", params).then(
        function (response) {
          if (!response.success) {
            that.managerDis = false;
            return;
          }
          if (response.resultCode === "1") {
            that.$message.closeAll();
            that.$message({
              message: "已确认完成",
              type: "success",
            });
          }
        }
      );
    },
    //下载
    async changeX(e, name) {
      this.current = e;
      this.visible = false;
      if (name === "修订痕迹") {
        e--;
      }
      if (name === "tmx") {
        const response = await this.catReq1Service("/api/v1/file/exportTransFileTmx", { id: this.fileId_, taskId: this.queryData.taskId })
        if (response.resultCode === "1") {
          window.open(
            response.result
          );
        }
      } else if (name === "xlf") {
        const response = await this.catReq1Service("/api/v1/file/exportTransFileXlf", { id: this.fileId_, taskId: this.queryData.taskId })
        if (response.resultCode === "1") {
          window.open(
            response.result
          );
        }
      } else {
        // window.open(
        //   `/cat/api/v1/file/download_transFile?type=${e}&fileId=${this.fileId_}&taskId=${this.queryData.taskId}`
        // );
        let taskUrl = ""
        this.queryData.taskId ? taskUrl = `&taskId=${this.queryData.taskId}` : ''
        let url = `/api/v1/file/downloadAsyncTransFile?type=${e}&fileId=${this.fileId_}${taskUrl}`;
        this.asynchronizationDownload(url)
      }

    },
    // 下载（异步）
    async asynchronizationDownload(url) {
      const response = await this.catReq1Service(url, {}, 'get')
      if (response.resultCode === "1") {
        const result = response.result;
        if (response.result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl)
        } else {
          this.setDownloadLoading();
          this.getDownloadAsyncResult(response.result.taskKey);
        }

      }
    },
    // 下载轮询
    async getDownloadAsyncResult(taskKey) {
      var setItem = setInterval(async () => {
        this.setDownloadLoading();
        const response = await this.catReq1Service('/api/v1/file/getDownloadAsyncResult', { taskKey }, 'get')
        if (response.resultCode === "1") {
          const result = response.result;
          if (result.percent == 100) {
            clearInterval(setItem);
            setItem = null;
            this.downloadLoading.close();
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          this.downloadLoading.close();
          setItem = null;
        }
      }, 2000);

    },
    setDownloadLoading() {
      this.downloadLoading = this.$loading({
        lock: true,
        text: '下载进度：' + this.downloadPercent + '%',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
    },
    // 下载指定的服务文件
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = "/cat" + `/api/v1/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      // window.open(
      //   "/cat" + `/api/v1/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`
      // );
    },
    visionPattern(e) {
      this.visible_one = false;
      this.$emit("visionPattern", e);
    },
    // 保存修改按钮
    updateSubmit() {
      this.$message.closeAll();
      this.$message({
        message: "保存成功!",
        type: "success",
      });
    },
    // 撤销
    onRetreat() {
      document.execCommand("Undo");
    },
    // 前进
    onAdvance() {
      document.execCommand("Redo");
    },
    seekShow() {
      this.$emit("seekShow");
    },
    rigBoxShow(data) {
      this.$emit("rigBoxShow", data);
    },
    // 设置修改痕迹
    setRecord1() {
      this.isRecord_ = !this.isRecord_;
      // sessionStorage.setItem("isRecord",this.isRecord_ );
      // this.$router.go(0);
      this.isScroll = false
      this.$emit("setRecord");
    },
    //确定打回重译
    async reTranslation() {
      console.log("queryData: ", this.queryData_)
      let param = {
        fileId: this.queryData_.fileId,
        id: this.queryData_.taskId,
        taskType: this.queryData_.taskType
      }
      const response = await this.catReq1Service('/api/v1/fileTask/rollBackTask', param)
      if (response.resultCode === "1") {
        this.$message({
          message: "任务已打回",
          type: "success",
        });
        this.retranslationDialogVisible = false
        this.operated = true
        this.$emit('reTranslate')
      }
    }
  },
};
</script>
<style lang="less" scoped>
.filterForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}
.topBox {
  padding-left: 13px;
  height: 32px;
  margin-left: 40px;
  line-height: 32px;
  margin: 10px 0;
  .disabled {
    // cursor: ;
  }
  .topBut {
    height: 26px;
    width: 40px;
    margin: 0 5px;
    position: relative;
    background: transparent;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .score_icon {
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      line-height: 16px;
      background: #ffffff;
      border: 2px solid #555555;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 400;
      color: #555555;
      box-sizing: border-box;
      img {
        position: absolute;
        left: 15px;
        top: 15px;
      }
      .el-icon-user {
        font-weight: bold;
      }
    }
  }
  .topBut:hover {
    outline: 1px solid rgba(214, 214, 214, 1);
  }
  .topBut:active {
    outline: 1px solid rgba(214, 214, 214, 1);
  }
  .activeBut {
    outline: 1px solid rgba(214, 214, 214, 1);
  }
  .progressBox {
    float: left;
  }
  .progress {
    width: 150px;
    display: inline-block;
    margin-left: 10px;
  }
  // 修改 下载 placeholder 颜色
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #606266;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #606266;
    opacity: 1;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #606266;
    opacity: 1;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #606266;
  }
  // 修改 下载 placeholder 颜色 结束
  /deep/.el-input {
    width: 105px;
  }
  button {
    // float: left;
  }
  .preservation {
    width: 26px;
    height: 23px;
    top: 5px;
    margin: 0px 15px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_bc.png") no-repeat;
  }
  // .preservation:hover {
  //   background: url("../../../assets/imgs/editor/preservation_hover.png")
  //     no-repeat;
  // }
  .retreat {
    width: 26px;
    height: 23px;
    top: 11px;
    position: relative;
    display: inline-block;
    background: url("../../../assets/imgs/editor/bz_cx.png") no-repeat;
  }
  .retreat :hover {
    background: url("../../../assets/imgs/editor/evoke_hover.png") no-repeat;
  }
  .advance {
    width: 26px;
    height: 23px;
    margin: 0px 15px;
    top: 11px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_hf.png") no-repeat;
  }
  .advance :hover {
    background: url("../../../assets/imgs/editor/recovery_hover.png") no-repeat;
  }
  .seekReplace {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_czth.png") no-repeat;
  }
  .seekReplace:hover {
    background: url("../../../assets/imgs/editor/lookup_hover.png") no-repeat;
  }
  .seekWord {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_cc.png") no-repeat;
  }
  .seekWord:hover {
    background: url("../../../assets/imgs/editor/word_search_hover.png")
      no-repeat;
  }
  .addTerms {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_tjsy.png") no-repeat;
  }
  .addTerms:hover {
    background: url("../../../assets/imgs/editor/add_to_hover.png") no-repeat;
  }
  .fontEnlarge {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_zt.png") no-repeat;
  }
  .fontEnlarge:hover {
    background: url("../../../assets/imgs/editor/lt_enlarge_hover.png")
      no-repeat;
  }
  .fontEnlarge:active {
    background: url("../../../assets/imgs/editor/lt_enlarge_press.png")
      no-repeat;
  }
  .fontNarrow {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/lt_narrow_normal.png")
      no-repeat;
  }
  .fontNarrow:hover {
    background: url("../../../assets/imgs/editor/lt_narrow_hover.png") no-repeat;
  }
  .fontNarrow:active {
    background: url("../../../assets/imgs/editor/lt_narrow_press.png") no-repeat;
  }
  .shortCut {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 8px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_kj.png") no-repeat;
  }
  .shortCut:hover {
    background: url("../../../assets/imgs/editor/shortcut_keys_hover.png")
      no-repeat;
  }

  .confirm {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/confirm_normal.png") no-repeat;
  }
  .confirm:hover {
    background: url("../../../assets/imgs/editor/confirm_hover.png") no-repeat;
  }
  .confirm:active {
    background: url("../../../assets/imgs/editor/confirm_press.png") no-repeat;
  }
  .complete {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_tj.png") no-repeat;
  }
  .complete:hover {
    background: url("../../../assets/imgs/editor/submit_tasks_hover.png")
      no-repeat;
  }
  .switching_styles {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    display: inline-block;
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: url("../../../assets/imgs/editor/bz_ms.png") no-repeat;
  }
  .switching_styles:hover {
    background: url("../../../assets/imgs/editor/layout_hover.png") no-repeat;
  }
  .pattern {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    display: inline-block;
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: url("../../../assets/imgs/editor/bz_msqh.png") no-repeat;
  }
  .pattern:hover {
    background: url("../../../assets/imgs/editor/brightness_mode_hover.png")
      no-repeat;
  }
  .download {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    display: inline-block;
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: url("../../../assets/imgs/editor/bz_xz.png") no-repeat;
  }
  .download:hover {
    background: url("../../../assets/imgs/editor/bj_download_hover.png")
      no-repeat;
  }
  .memory_bank {
    width: 24px;
    height: 24px;
    margin: 0px 14px;
    top: 4px;
    position: relative;
    background: url("../../../assets/imgs/editor/bz_tjjy.png") no-repeat;
  }
  .memory_bank:hover {
    background: url("../../../assets/imgs/editor/upload_memory_hover.png")
      no-repeat;
  }
  .el-button {
    float: left;
    height: 32px;
    line-height: 32px;
    padding: 0px 20px;
  }
  .el-button {
    margin-left: 10px;
  }
  p {
    float: left;
    margin-left: 30px;
  }
}
/deep/.el-select {
  .el-input {
    width: 130px;
  }
}
/deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
}
#shortcutKey {
  li {
    // color: aqua;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    height: 30px;
    p:nth-child(1) {
      width: 200px;
      float: left;
    }
    p {
      height: auto;
      margin: 0px;
      padding: 0px;
      margin-bottom: 10px;
    }
  }
  .tit {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
.backColorB {
  color: rgb(170, 171, 173) !important;
  /deep/.el-progress__text {
    color: rgb(170, 171, 173) !important;
  }
  div {
    button:hover {
      //  background: #405964 !important;
    }
    button:active {
      // background: #2c4753 !important;
    }
  }
  .topBut:hover {
    outline: 1px solid rgba(82, 89, 99, 1) !important;
  }
  .topBut:active {
    outline: 1px solid rgba(82, 89, 99, 1) !important;
  }
  .activeBut {
    outline: 1px solid rgba(82, 89, 99, 1) !important;
  }
  /deep/.el-input {
    input::-webkit-input-placeholder {
      color: white !important;
    }
  }
}
.active {
  background-color: #454545;
}
.popoverBox {
  li:hover {
    background: #f1f1f1;
  }
  li {
    padding: 3px;
  }
}
.scoreListTit {
  text-align: center;
  position: relative;
  font-weight: bold;
  color: #454545;
  border-bottom: 1px solid #ece6e6;
  padding-bottom: 8px;
  height: 26px;
  line-height: 26px;
  i {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-12px);
    font-size: 16px;
    cursor: pointer;
  }
}
.scoreList {
  text-align: center;
  .scoreTh {
    font-weight: bold;
    color: #566087;
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    span {
      width: 70px;
    }
  }
  .scoreItem {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .interpreterName {
      width: 70px;
      cursor: pointer;
      &:hover {
        color: #3e78ee;
      }
    }
    .interpreterAct {
      color: #3e78ee;
    }

    /deep/.el-input {
      width: 70px !important;
      .el-input__inner {
        background-color: #f9f9f9;
      }
    }
  }
}
.scoreListT {
  padding-top: 10px;
  .scoreItem {
    justify-content: center;
  }
}
/*表格样式 开始*/
/deep/ .has-gutter {
  tr {
    th {
      text-align: center;
      color: #333333;
    }
  }
}
.operation {
  display: flex;
  justify-content: center;
  .icon_delete {
    margin: 5px 5px 0 10px;
    height: 20px;
    width: 20px;
    background: url("../../../assets/imgs/editor/transDel.png") no-repeat left
      center;
  }
  .icon_delete:hover {
    background: url("../../../assets/imgs/editor/transDel2.png") no-repeat left
      center;
  }
}
/deep/.el-table__body {
  tbody {
    tr:first-child {
      td:last-child {
        .cell {
          .operation {
            display: none;
          }
        }
      }
    }
    tr {
      td {
        border: 1px solid #ebeef5;
      }
      td:first-child {
        .cell {
          text-align: center;
        }
      }
    }
  }
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
  background: #f7f7f7;
  height: 360px;
}
.term-input {
  width: 98%;
  height: 35px;
  border: none;
  padding: 0 5px;
  line-height: 30px;
  background: #f8f8f8;
}
/*表格样式  结束*/
/*弹框样式 loading 开始*/
/deep/.extract_terms {
  .el-dialog {
    border-radius: 3px;
    button {
      width: 200px;
      height: 30px;
    }
    .el-dialog__header {
      padding: 10px 20px;
      height: 15px;
    }
    .el-dialog__body {
      height: 200px;
      .extract_terms_loading {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-top: 30px;
          width: 30px;
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
/deep/.extract_terms_table {
  .el-dialog {
    .extract_terms_table_title {
      height: 30px;
      line-height: 30px;
      color: #1f78d2;
      border-top: 1px solid rgba(228, 228, 228, 1);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(31, 120, 210, 1);
      line-height: 24px;
      padding-top: 5px;
    }
    .el-dialog__header {
      padding: 10px 20px;
      height: 15px;
    }
    .el-dialog__body {
      height: 500px;
      // overflow: auto;
      .extract_terms_loading {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-top: 30px;
          width: 30px;
        }
      }
    }
    .dialog-footer {
      height: 30px;
      display: flex;
      justify-content: center;
      button {
        height: 36px;
        width: auto;
      }
    }
  }
}
.division {
  height: 30px;
  border-top: 1px solid rgba(228, 228, 228, 1);
}
/*弹框样式  结束*/
/*打回重译确认弹窗*/
/deep/ .retranslationDialog {
  .el-dialog {
    width: 20%;
    box-shadow: 0 2px 8px 0 rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    margin-top: 0 !important;
  }
  .el-dialog__header {
    width: 90%;
    margin: 0 auto;
    height: 48px;
    text-align: center;
    border-bottom: 1px solid #dfe4e8;
    padding: 0;
    line-height: 48px;
    .el-dialog__headerbtn {
      display: none;
    }
  }
  .el-dialog__body {
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #333;
    padding: 40px 20px;
  }
  .el-dialog__footer {
    height: 68px;
    display: flex;
    justify-content: center;
    padding: 0 !important;
    padding-top: 0 !important;
    button {
      width: 90px;
      height: 36px;
      font-size: 16px;
    }
    .cancel-btn {
      box-shadow: 1px 3px 8px 0 rgba(2, 136, 210, 0.5);
      border-radius: 4px;
      background: #e9f7ff;
      border: 1px solid #5256e9;
      color: #5256e9;
    }
    .confirm-btn {
      background: #5256e9;
      border: 1px solid #5256e9;
      -webkit-box-shadow: 1px 3px 8px 0 rgba(82, 86, 233, 0.5);
      box-shadow: 1px 3px 8px 0 rgba(82, 86, 233, 0.5);
      border-radius: 4px;
      color: #fff;
      margin-left: 30px;
    }
  }
}

.submit-hint {
  position: fixed;
  background: #fff;
  z-index: 200;
  width: 150px;
  font-size: 12px;
  line-height: 20px;
  padding: 10px;
  box-shadow: 0px 0px 10px 0px rgba(209, 212, 218, 0.6);
  border-radius: 10px;
  border: 1px solid #ebeef5;
  i {
    position: absolute;
    right: 20px;
    top: 10px;
    cursor: pointer;
  }
  p {
    margin-left: 0;
    margin-top: 20px;
  }
  .submit-arrow::after,
  .submit-arrow {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .submit-arrow {
    top: -12px;
    right: 16px;
    // margin-right: 3px;
    border-top-width: 0;
    border-bottom-color: #ebeef5;
    border-width: 6px;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    // box-shadow: 0px 0px 10px 0px rgba(209, 212, 218, 0.6);
  }

  .submit-arrow::after {
    content: " ";
    border-width: 6px;
    top: 1px;
    margin-left: -6px;
    border-top-width: 0;
    border-bottom-color: #fff;
  }
}

// 译员评分弹窗
/deep/ .interpreterDialog {
  .el-dialog {
    width: 480px !important;
    .el-input {
      width: 220px;
      .el-input__inner {
        background-color: #f9f9f9;
      }
    }
  }
  .el-dialog__body {
    padding-top: 20px;
  }
}
.interpreterHint {
  font-size: 12px;
  color: #a1a1a1;
  float: right !important;
  margin-left: 0px;
  width: 250px;
  text-align: left;
  line-height: 20px;
}
.interpreterList {
  padding: 0 40px;
  text-align: left;
  max-height: 230px;
  overflow: auto;
  .bottom {
    height: 6px;
  }
  .tit {
    display: flex;
    align-items: center;
    // height: 18px;
    .line {
      display: inline-block;
      width: 4px;
      height: 16px;
      border: 0px solid #bdbbba;
      background: linear-gradient(0deg, #387cec 0%, #8eb5fc 100%);
      border-radius: 2px;
      margin-right: 8px;
    }
    .interpreterName {
      font-weight: bold;
      color: #454545;
    }
  }
  .inputBox {
    text-align: right;
  }
  .accuracyScore {
    margin-bottom: 14px;
  }
}
// 译员评分弹窗
</style>
<style lang="less">
.el-loading-spinner {
  font-size: 36px;
  .el-icon-loading {
    color: #fff !important;
  }
  .el-loading-text {
    color: #fff !important;
  }
}
</style>
